/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-11 16:55:04
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-14 10:00:29
 * @name: 通讯录-个人资料
 * @Description: 通讯录-个人资料
 * @FilePath: \preSaleNafterSaleInside\project\src\Validator\department\getDetail.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'user_id',
    description: '后台用户id',
    required: true,
    required_message: '后台用户id为必传项',
    match: (e) => {
      return '';
    }
  },
]